import { Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import bottom from '@assets/bottom.png';
import { Navigation } from '@components';
import { ErrorCode, ROUTE_ARR, dhgate } from '@constants';
import SeelLogo from '@assets/seel_logo.svg';
import { ErrorPage } from '../error';
import classes from './index.module.css';

export const Layout = () => {
  const { pathname, search } = useLocation();
  const { orderNumber, platform } = useSelector((state) => state.policy);
  const { merchantId } = useSelector((state) => state.claim);
  let isLoginPage = ROUTE_ARR.includes(pathname) || pathname === `/${dhgate}` || pathname === `/${platform}/feedback` || !!pathname;
  if (search?.indexOf('debug=1') > -1) {
    isLoginPage = true;
  }

  return (
    <>
      <Navigation platform={platform} merchantId={merchantId} />
      <div className={classes.placeholder} />
      <div className={classes.content}>
        {(orderNumber || isLoginPage) ? <Outlet /> : <ErrorPage code={ErrorCode.Refresh} />}
      </div>
      {!isLoginPage ? (
        <div className={classes.bottom}>
          <img src={bottom} alt="" className={classes.bottom_img} />
          {platform === 'gently' && (
            <span className={`${classes.bottom_text} ${pathname === '/feedback' ? classes.feedback_bottom_text : null}`}>
              POWERED BY
              <img src={SeelLogo} alt="" className={classes.bottom_seel_logo} />
            </span>
          )}
        </div>
      ) : null}
    </>
  );
};
